module.exports = __webpack_public_path__ + "static/media/calendar-blue.47a35d0f.svg";